import React, { useEffect, useState } from 'react';
import { NavLink, Link, useNavigate } from "react-router-dom";
import Alert from 'react-bootstrap/Alert';
import Users from "../assets/images/users.png";

import { FaRegUser, FaFolderOpen, FaHeart, FaAddressCard, FaSignOutAlt } from "react-icons/fa";


const Sidebar = (props) => {
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const navigate = useNavigate();

    function logOut() {
        setShow(false);
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('cart');

        localStorage.removeItem("instockonly");
        localStorage.removeItem("priceRange");
        localStorage.removeItem("selectedFilters");
        localStorage.removeItem("selectedSortBy");

        navigate("/");
        window.location.reload(true);
    }

    useEffect(() => {
        const storedData = localStorage.getItem("userData");
        if (storedData) {
            setData(JSON.parse(storedData));
        }
    }, [props.data])

    return (
        <>
            <aside className="side">
                <div className="side-card profile">
                    <div className="profile-top">
                        <div className="avatar">
                            <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="4" fill="#12bfa0" /><path d="M4 20c0-4 3.5-6 8-6s8 2 8 6" fill="#12bfa0" /></svg>
                        </div>
                        <div>
                            <div className="p-name">{data.first_name} {data.last_name}</div>
                            {data?.mobile_no != '' && (<div className="p-mail">{data?.mobile_no}</div>)}
                        </div>
                    </div>
                </div>

                <nav className="side-card side-nav">
                    <NavLink className="nav-i" to="/profile">
                        <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8"><circle cx="12" cy="8" r="3.4"></circle><path d="M5.5 20c0-3.6 3-5.5 6.5-5.5s6.5 1.9 6.5 5.5"></path></svg>
                        My Profile
                    </NavLink>
                    <NavLink className="nav-i" to="/myorders">
                        <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8"><path d="M6 8h12l-1 12H7L6 8Z" /><path d="M9 8V6a3 3 0 0 1 6 0v2" /></svg>
                        My Orders
                    </NavLink>

                    <NavLink className="nav-i" to="/wishlist">
                        <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8"><path d="M12 20s-7-4.3-7-9.5A4.2 4.2 0 0 1 12 7a4.2 4.2 0 0 1 7 3.5C19 15.7 12 20 12 20Z" /></svg>
                        Wishlist
                    </NavLink>
                    <NavLink className="nav-i" to="/manage-addresses">
                        <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8"><path d="M12 21s-7-5.5-7-11a7 7 0 0 1 14 0c0 5.5-7 11-7 11Z" /><circle cx="12" cy="10" r="2.6" /></svg>
                        Manage Addresses
                    </NavLink>

                    <Link className="nav-i" onClick={() => setShow(true)}>
                        <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
                            <path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3" />
                            <path d="M10 12h9" /><path d="m16 9 3 3-3 3" />
                            <path d="M10 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4" />
                        </svg>Logout</Link>
                </nav>

                <div className="side-card help">
                    <h4>Need Help?</h4>
                    <p>We're here to help you with your orders.</p>
                    <button className="btn-support">
                        <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8"><path d="M4 13v-1a8 8 0 0 1 16 0v1" /><rect x="3" y="13" width="4" height="6" rx="1.5" /><rect x="17" y="13" width="4" height="6" rx="1.5" /><path d="M20 19a4 4 0 0 1-4 3h-2" /></svg>
                        Contact Support
                    </button>
                </div>
            </aside>
            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Logout?</Alert.Heading>
                    <hr />
                    <div className='buttons'>
                        <div>
                            <button onClick={() => logOut()} className='btn btn-green'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-red'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}
        </>
    );
}

export default Sidebar